export const environment = {
  production: false,
  baseUIPath: '',
  serviceName: 'stratus-ui',
  envName: 'dev',
  swpIamBaseUrl: 'https://swp-iam-dev.bcg.com/api',
};
